export type Element = {
  key:string,
  name:string
}

export const countryDictionary  : Element[] = [
    
    { key: 'DE', name: 'Allemagne' },
    { key: 'AT', name: 'Autriche' },
    { key: 'BE', name:  'Belgique'},
    
    { key: 'BG', name:  'Bulgarie' },
    { key: 'CY', name:  'Chypre' },
    { key: 'HR', name:  'Croatie' },
    { key: 'DK', name:  'Danemark' },
    { key: 'ES', name:  'Espagne' },
    { key: 'EE', name:  'Estonie' },
    { key: 'FI', name:  'Finlande' },
    { key: 'FR', name:  'France' },
    { key: 'GR', name:  'Grèce' },
    { key: 'HU', name:  'Hongrie' },
    { key: 'IE', name:  'Irlande' },
    { key: 'IT', name:  'Italie' },
    { key: 'LV', name:  'Lettonie' },
    { key: 'LT', name:  'Lituanie' },
    { key: 'LU', name:  'Luxembourg' },
    { key: 'MT', name:  'Malte' },
    { key: 'NL', name:  'Pays-Bas' },
    { key: 'PL', name:  'Pologne' },
    { key: 'PT', name:  'Portugal' },
    { key: 'CZ', name:  'République tchèque'},
    { key: 'RO', name:  'Roumanie'},
    { key: 'SK', name:  'Slovaquie'},
    { key: 'SI', name:  'Slovénie'},
    { key: 'SE', name:  'Suède'},
    { key: 'GB', name:  'Royaume-Uni'},
    { key: 'TR', name:  'Turquie'},
  ];

export const regionDictionary: Element[]=[
  { key: '01', name: 'Ain'},
    { key: '02', name: 'Aisne'},
    { key: '03', name: 'Allier'},
    { key: '04', name: 'Alpes-de-Haute-Provence'},
    { key: '05', name: 'Hautes-Alpes'},
    { key: '06', name: 'Alpes-Maritimes'},
    { key: '07', name: 'Ardèche'},
    { key: '08', name: 'Ardennes'},
    { key: '09', name: 'Ariège'},
    { key: '10', name: 'Aube'},
    { key: '11', name: 'Aude'},
    { key: '12', name: 'Aveyron'},
    { key: '13', name: 'Bouches-du-Rhône'},
    { key: '14', name: 'Calvados'},
    { key: '15', name: 'Cantal'},
    { key: '16', name: 'Charente'},
    { key: '17', name: 'Charente-Maritime'},
    { key: '18', name: 'Cher'},
    { key: '19', name: 'Corrèze'},
    { key: '2A', name: 'Corse-du-Sud'},
    { key: '2B', name: 'Haute-Corse'},
    { key: '21', name: 'Côte-d\'Or'},
    { key: '22', name: 'Côtes-d\'Armor'},
    { key: '23', name: 'Creuse'},
    { key: '24', name: 'Dordogne'},
    { key: '25', name: 'Doubs'},
    { key: '26', name: 'Drôme'},
    { key: '27', name: 'Eure'},
    { key: '28', name: 'Eure-et-Loir'},
    { key: '29', name: 'Finistère'},
    { key: '30', name: 'Gard'},
    { key: '31', name: 'Haute-Garonne'},
    { key: '32', name: 'Gers'},
    { key: '33', name: 'Gironde'},
    { key: '34', name: 'Hérault'},
    { key: '35', name: 'Ille-et-Vilaine'},
    { key: '36', name: 'Indre'},
    { key: '37', name: 'Indre-et-Loire'},
    { key: '38', name: 'Isère'},
    { key: '39', name: 'Jura'},
    { key: '40', name: 'Landes'},
    { key: '41', name: 'Loir-et-Cher'},
    { key: '42', name: 'Loire'},
    { key: '43', name: 'Haute-Loire'},
    { key: '44', name: 'Loire-Atlantique'},
    { key: '45', name: 'Loiret'},
    { key: '46', name: 'Lot'},
    { key: '47', name: 'Lot-et-Garonne'},
    { key: '48', name: 'Lozère'},
    { key: '49', name: 'Maine-et-Loire'},
    { key: '50', name: 'Manche'},
    { key: '51', name: 'Marne'},
    { key: '52', name: 'Haute-Marne'},
    { key: '53', name: 'Mayenne'},
    { key: '54', name: 'Meurthe-et-Moselle'},
    { key: '55', name: 'Meuse'},
    { key: '56', name: 'Morbihan'},
    { key: '57', name: 'Moselle'},
    { key: '58', name: 'Nièvre'},
    { key: '59', name: 'Nord'},
    { key: '60', name: 'Oise'},
    { key: '61', name: 'Orne'},
    { key: '62', name: 'Pas-de-Calais'},
    { key: '63', name: 'Puy-de-Dôme'},
    { key: '64', name: 'Pyrénées-Atlantiques'},
    { key: '65', name: 'Hautes-Pyrénées'},
    { key: '66', name: 'Pyrénées-Orientales'},
    { key: '67', name: 'Bas-Rhin'},
    { key: '68', name: 'Haut-Rhin'},
    { key: '69', name: 'Rhône'},
    { key: '70', name: 'Haute-Saône'},
    { key: '71', name: 'Saône-et-Loire'},
    { key: '72', name: 'Sarthe'},
    { key: '73', name: 'Savoie'},
    { key: '74', name: 'Haute-Savoie'},
    { key: '75', name: 'Paris'},
    { key: '76', name: 'Seine-Maritime'},
    { key: '77', name: 'Seine-et-Marne'},
    { key: '78', name: 'Yvelines'},
    { key: '79', name: 'Deux-Sèvres'},
    { key: '80', name: 'Somme'},
    { key: '81', name: 'Tarn'},
    { key: '82', name: 'Tarn-et-Garonne'},
    { key: '83', name: 'Var'},
    { key: '84', name: 'Vaucluse'},
    { key: '85', name: 'Vendée'},
    { key: '86', name: 'Vienne'},
    { key: '87', name: 'Haute-Vienne'},
    { key: '88', name: 'Vosges'},
    { key: '89', name: 'Yonne'},
    { key: '90', name: 'Territoire de Belfort'},
    { key: '91', name: 'Essonne'},
    { key: '92', name: 'Hauts-de-Seine'},
    { key: '93', name: 'Seine-Saint-Denis'},
    { key: '94', name: 'Val-de-Marne'},
    { key: '95', name: 'Val-d\'Oise'},
    { key: '971', name: 'Guadeloupe'},
    { key: '972', name: 'Martinique'},
    { key: '973', name: 'Guyane'},
    { key: '974', name: 'La Réunion'},
    { key: '976', name: 'Mayotte'},
]